<template>
  <div>
    <div class="integral_title">
      <div class="integral_title_one">我的积分</div>
      <div class="integral_title_two">
        <div>
          <p>可用积分</p>
          <p>0</p>
        </div>
        <div>
          <p>积分明细>></p>
          <p>兑换记录>></p>
        </div>
      </div>
    </div>
    <div class="integral_count">
      <div class="integral_count_one">已经连续签到<span>1</span>天</div>
      <div class="integral_count_two">
        <div>
          <p>
            <img src="@/assets/img/integral/1.png" alt="" />
          </p>
          <p>第一天</p>
        </div>
        <div>
          <p>
            <img src="@/assets/img/integral/2.png" alt="" />
          </p>
          <p>第二天</p>
        </div>
        <div>
          <p><img src="@/assets/img/integral/3.png" alt="" /></p>
          <p>第三天</p>
        </div>
        <div>
          <p><img src="@/assets/img/integral/4.png" alt="" /></p>
          <p>第四天</p>
        </div>
        <div>
          <p><img src="@/assets/img/integral/5.png" alt="" /></p>
          <p>第五天</p>
        </div>
        <div>
          <p><img src="@/assets/img/integral/6.png" alt="" /></p>
          <p>第六天</p>
        </div>
        <div>
          <p><img src="@/assets/img/integral/7.png" alt="" /></p>
          <p>第七天</p>
        </div>
      </div>
      <div class="btn">我要签到</div>
    </div>
    <div class="integral_task">
      <p>完成人物赚积分</p>
      <div class="integral_task_one">
        <div class="task_1"></div>
        <div class="task_2">
          <div>收藏1个新房项目</div>
          <div>每天收藏一个新房项目</div>
          <div class="task_2_middle">
            <div class="step">
              <div></div>
            </div>
            <div class="num">0/1</div>
          </div>
        </div>
        <div class="task_3">+2</div>
      </div>
      <div class="more">去任务中心查看所有任务以及积分获取途径 ></div>
    </div>
    <div class="integral_gift">
      <p>精选好物兑换</p>
      <div class="integral_gift_flex">
        <div>
          <div><img src="" alt="" /></div>
          <div class="gift_flex_2">嘻嘻嘻哈哈</div>
          <div class="gift_flex_3">899积分</div>
        </div>
      </div>
      <div class="more">去积分商城查看所有好物 ></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.integral_title {
  .integral_title_one {
    text-align: center;
    color: #000;
    font-weight: 900;
    font-size: 0.4rem;
  }
  .integral_title_two {
    display: flex;
    div {
      padding: 0.5rem 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      p {
        padding: 0.1rem;
        color: #007fff;
        padding-right: 0.4rem;
        text-align: right;
      }
    }
  }
}
.integral_count {
  width: 90%;
  margin: 0 auto;
  .integral_count_one {
    padding: 0.2rem 0 0.2rem 0.3rem;
    font-size: 0.3rem;
    span {
      color: red;
    }
  }
  .integral_count_two {
    padding: 0.3rem 0;
    display: flex;
    div {
      flex: 1;
      p {
        width: 100%;
        text-align: center;
        img {
          width: 0.5rem;
        }
      }
    }
  }
  .btn {
    text-align: center;
    padding: 0.15rem;
    background: #007fff;
    color: #fff;
    font-size: 0.3rem;
    width: 35%;
    margin: 0 auto;
  }
}
.integral_task {
  padding: 0.2rem 0.3rem;
  & > p {
    font-size: 0.3rem;
    font-weight: 900;
  }
  .integral_task_one {
    display: flex;
    margin-top: 0.1rem;
    .task_1 {
      flex: 0 1 20%;
    }
    .task_2 {
      flex: 0 1 70%;
      & > div {
        margin-top: 0.1rem;
      }
      .task_2_middle {
        align-items: center;
        display: flex;
        .step {
          width: 70%;
          height: 0.07rem;
          position: relative;
          background: #cfcfcf;
          overflow: hidden;
          border-radius: 5%;
          div {
            width: 50%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background: #99ccff;
          }
        }
        .num {
          margin-left: 0.3rem;
        }
      }
    }
    .task_3 {
      display: flex;
      align-items: center;
      font-size: 0.3rem;
      font-weight: 900;
      flex: 0 1 10%;
      color: #ff0000;
    }
  }
  .more {
    margin-top: 0.5rem;
    font-weight: 900;
    text-align: center;
  }
}
.integral_gift {
  padding: 0.2rem 0.4rem;
  & > p {
    font-size: 0.3rem;
    font-weight: 900;
  }
  .integral_gift_flex {
    display: flex;
    justify-content: space-between;
    & > div {
      margin-top: 0.2rem;
      flex: 0 1 45%;
      border-radius: 5%;
      box-shadow: 0 0 5px rgba(207, 207, 207, 0.5);
      .gift_flex_2 {
        text-align: center;
        padding: 0.3rem 0.2rem;
        overflow: hidden;
        font-size: 0.3rem;
      }
      .gift_flex_3 {
        font-size: 0.3rem;
        padding: 0.5rem 0 0.5rem 0.3rem;
        color: #ff0000;
      }
    }
  }
}
</style>